document.addEventListener("DOMContentLoaded", function () {
  const panel = document.querySelector(".bd-pd-standalone-panel");
  if (!panel) return;

  // Hidden CHF 0.00 "PD-Wert Nachreichung" product (no shipping required).
  const PD_STANDALONE_VARIANT_ID = 54648782946631;

  const stepWelcome = document.getElementById("bdPdSaStepWelcome");
  const stepContact = document.getElementById("bdPdSaStepContact");

  const progressFill = document.getElementById("bdPdSaProgressFill");
  const welcomeNext  = document.getElementById("bdPdSaWelcomeNext");
  const finalR       = document.getElementById("bdPdSaFinalR");
  const finalL       = document.getElementById("bdPdSaFinalL");
  const resolvedNote = document.getElementById("bdPdSaResolvedNote");

  const contactBack  = document.getElementById("bdPdSaContactBack");
  const contactNext  = document.getElementById("bdPdSaContactNext");
  const contactError = document.getElementById("bdPdSaContactError");
  const nameField    = document.getElementById("bdPdSaName");
  const orderField   = document.getElementById("bdPdSaOrderNumber");
  const messageField = document.getElementById("bdPdSaMessage");

  let pdResolution = null; // 'known' | 'photo'
  let pdPhotoInput = null;
  let isSubmitting = false;

  const steps = { welcome: stepWelcome, contact: stepContact };
  const progress = { welcome: "25%", contact: "75%" };

  function showStep(name) {
    Object.keys(steps).forEach(function (k) {
      if (steps[k]) steps[k].style.display = k === name ? "block" : "none";
    });
    if (progressFill && progress[name]) progressFill.style.width = progress[name];
  }

  if (contactBack) contactBack.addEventListener("click", function () { showStep("welcome"); });

  // Anyone reaching this page never knows their PD (otherwise they'd have
  // given it during checkout already) — so skip straight into the photo
  // flow. The "PD aus Sehtest eingeben" link inside that flow's first step
  // still covers the rare case where someone does know the value after all.
  if (welcomeNext) {
    welcomeNext.addEventListener("click", function () {
      if (!window.BdPd) return;
      window.BdPd.open({
        fieldIds: { r: "bdPdSaFinalR", l: "bdPdSaFinalL" },
        hostPanel: panel,
        currentStepEl: stepWelcome,
        confirmNoteEl: resolvedNote,
        onPhotoAttached: function (fileInput) {
          pdPhotoInput = fileInput;
          pdResolution = "photo";
          showStep("contact");
          // BdPd's own close() (called right after this callback) restores
          // currentStepEl's visibility unconditionally — re-hide it on the
          // next tick so only the Kontaktdaten step stays visible.
          setTimeout(function () { stepWelcome.style.display = "none"; }, 0);
        },
        onManualConfirmed: function () {
          pdResolution = "known";
          pdPhotoInput = null;
          showStep("contact");
          setTimeout(function () { stepWelcome.style.display = "none"; }, 0);
        }
      });
    });
  }

  function addFileToForm(fileInput, propName, form) {
    if (!fileInput) return;
    if (!form.contains(fileInput)) form.appendChild(fileInput);
    form.setAttribute("enctype", "multipart/form-data");
    fileInput.name = "properties[" + propName + "]";
  }

  async function flagOnCartNote(text) {
    try {
      const cart = await (await fetch("/cart.js")).json();
      const existing = cart.note || "";
      const note = existing ? existing + "\n" + text : text;
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: JSON.stringify({ note: note }),
      });
    } catch (err) {
      console.error(err);
    }
  }

  if (contactNext) {
    contactNext.addEventListener("click", async function () {
      if (isSubmitting) return;
      const name  = nameField ? nameField.value.trim() : "";
      const order = orderField ? orderField.value.trim() : "";
      if (!name) {
        if (contactError) contactError.style.display = "flex";
        return;
      }
      if (contactError) contactError.style.display = "none";

      if (!PD_STANDALONE_VARIANT_ID) {
        alert("Diese Seite ist noch nicht vollständig eingerichtet (fehlende Produkt-ID). Bitte kontaktiere uns direkt unter info@brillendeal.ch.");
        return;
      }

      isSubmitting = true;
      contactNext.disabled = true;

      try {
        const form = document.createElement("form");
        form.style.display = "none";
        document.body.appendChild(form);

        function setProp(propName, value) {
          const input = document.createElement("input");
          input.type = "hidden";
          input.name = "properties[" + propName + "]";
          input.value = value;
          form.appendChild(input);
        }

        const idInput = document.createElement("input");
        idInput.type = "hidden";
        idInput.name = "id";
        idInput.value = String(PD_STANDALONE_VARIANT_ID);
        form.appendChild(idInput);

        const qtyInput = document.createElement("input");
        qtyInput.type = "hidden";
        qtyInput.name = "quantity";
        qtyInput.value = "1";
        form.appendChild(qtyInput);

        setProp("Name", name);
        if (order) setProp("Bestellnummer", order);
        if (messageField && messageField.value.trim()) setProp("Nachricht", messageField.value.trim());

        if (pdResolution === "known" && finalR.value && finalL.value) {
          setProp("PD Rechts", finalR.value + " mm");
          setProp("PD Links", finalL.value + " mm");
        } else if (pdResolution === "photo" && pdPhotoInput) {
          setProp("PD Wert", "Siehe hochgeladenes Foto (Massstab) — wird von unserem Team ausgelesen");
          addFileToForm(pdPhotoInput, "PD Foto", form);
        }

        const fd = new FormData(form);
        const res = await fetch("/cart/add", {
          method: "POST",
          body: fd,
          headers: { "X-Requested-With": "XMLHttpRequest" },
        });
        if (!res.ok) throw new Error(await res.text());

        await flagOnCartNote(
          "🚨 PD-NACHREICHUNG — " + name + (order ? " (Bestellnummer " + order + ")" : " (keine Bestellnummer angegeben)") +
          " — Pupillendistanz der Bestellung zuordnen" +
          (pdResolution === "photo" ? " (Foto liegt bei, auslesen!)" : "")
        );

        // A real, trackable order (with the file attachment) only exists once
        // checkout completes — redirect straight there. The product has no
        // price/shipping, so this is a single quick step for the customer.
        // Email isn't collected on this page — the customer gives it right
        // there in checkout, so it ends up on the order either way.
        window.location.href = "/checkout";
      } catch (err) {
        console.error(err);
        alert("Ups – etwas hat nicht geklappt. Bitte versuch es nochmal oder schreib uns direkt an info@brillendeal.ch.");
        isSubmitting = false;
        contactNext.disabled = false;
      }
    });
  }
});
